document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    initStickyAddToCart();
  }, 500);

  function initStickyAddToCart() {
    const stickyElement = document.getElementById('stickyAddToCart');

    if (!stickyElement) {
      console.warn('Sticky add to cart element not found');
      return;
    }

    // Try to find product section - GemPages OR standard Shopify
    const productSection = 
      document.querySelector('gp-product') || // Generic GemPages product element
      document.querySelector('[data-uid*="g"]') || // Any GemPages element with uid
      document.querySelector('.shop-product-section') || // Your original selector
      document.querySelector('.product, .product-section, [data-section-type="product"]') || // Standard Shopify
      document.querySelector('main'); // Fallback

    if (!productSection) {
      console.warn('Product section not found');
      return;
    }

    // Combined selectors - GemPages first, then standard Shopify
    const addToCartSelectors = [
      // GemPages generic selectors (will work for ANY GemPages product)
      'gp-product-button button[type="submit"]:not(.gp-button-sold-out)',
      'product-form button[type="submit"]:not(.gp-button-sold-out)',
      'button.gp-button-atc:not(.gp-button-sold-out)',
      'button.tcustomizer-submit-button:not(.gp-button-sold-out)',
      '.gp-button-base[type="submit"]:not(.gp-button-sold-out)',
      'gp-button button[type="submit"]:not(.gp-button-sold-out)',
      'form[action*="/cart/add"] button.gp-button-base:not(.gp-button-sold-out)',
      // Standard Shopify selectors
      'button[name="add"]:not([disabled])',
      'button.add-to-cart:not([disabled])',
      'button.add-to-cart-button:not([disabled])',
      'button.product-form__cart-submit:not([disabled])',
      'button.product-form__submit:not([disabled])',
      'form[action*="/cart/add"] button[type="submit"]:not([disabled])',
      '.ProductForm__AddToCart:not([disabled])'
    ];

    let addToCartButton = null;

    // Try to find the add to cart button
    for (const selector of addToCartSelectors) {
      const buttons = productSection.querySelectorAll(selector);
      
      // Filter out hidden/sold-out buttons
      for (const button of buttons) {
        const isHidden = 
          button.classList.contains('gp-button-sold-out') ||
          button.disabled ||
          button.getAttribute('gp-data-hidden') === 'true' ||
          button.closest('[gp-data-hidden="true"]') ||
          button.style.display === 'none' ||
          button.offsetParent === null; // Check if visually hidden
        
        if (!isHidden) {
          addToCartButton = button;
          console.log('Found add to cart button:', selector);
          break;
        }
      }
      
      if (addToCartButton) break;
    }

    if (!addToCartButton) {
      console.warn('Add to cart button not found, setting up observer...');
      
      const observer = new MutationObserver(function (mutations) {
        if (addToCartButton) return; // Already found
        
        for (const selector of addToCartSelectors) {
          const buttons = productSection.querySelectorAll(selector);
          
          for (const button of buttons) {
            const isHidden = 
              button.classList.contains('gp-button-sold-out') ||
              button.disabled ||
              button.getAttribute('gp-data-hidden') === 'true' ||
              button.closest('[gp-data-hidden="true"]') ||
              button.style.display === 'none' ||
              button.offsetParent === null;
            
            if (!isHidden) {
              addToCartButton = button;
              console.log('Found add to cart button via observer:', selector);
              observer.disconnect();
              setupScrollHandler();
              return;
            }
          }
        }
      });

      observer.observe(productSection, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['gp-data-hidden', 'disabled', 'style']
      });

      setTimeout(function () {
        observer.disconnect();
        if (!addToCartButton) {
          console.error('Could not find add to cart button after 10 seconds');
        }
      }, 10000);
    } else {
      setupScrollHandler();
    }

    function setupScrollHandler() {
      if (!addToCartButton) {
        console.error('Cannot setup scroll handler without add to cart button');
        return;
      }

      const scrollThreshold = -100;
      let isVisible = false;
      let debounceTimer = null;

      function handleScroll() {
        if (!addToCartButton) return;

        // Shipping info visibility
        const desktopShipping = document.querySelector('.sticky-add-to-cart__shipping');
        const mobileShipping = document.querySelector('.mobile-shipping-info');

        if (desktopShipping && window.stickySettings) {
          if (
            window.stickySettings.showDesktopShipping === false ||
            window.stickySettings.showDeliveryDate === false
          ) {
            desktopShipping.style.display = 'none';
            desktopShipping.setAttribute('aria-hidden', 'true');
          }
        }

        if (mobileShipping && window.stickySettings) {
          if (
            window.stickySettings.showMobileShipping === false ||
            window.stickySettings.showDeliveryDate === false
          ) {
            mobileShipping.style.display = 'none';
            mobileShipping.setAttribute('aria-hidden', 'true');
          }
        }

        // Detect cart drawer open - both GemPages AND standard Shopify
        const cartDrawerWrapper = document.querySelector(
          'cart-drawer.drawer, .drawer.cart-drawer, .cart-drawer, gp-cart-drawer'
        );
        const cartSidebar = document.querySelector(
          '#sidebar-cart, #CartDrawer, .cart-sidebar, .gp-cart-sidebar'
        );

        const isCartOpen =
          (cartDrawerWrapper &&
            (cartDrawerWrapper.classList.contains('active') ||
              cartDrawerWrapper.classList.contains('is-open') ||
              cartDrawerWrapper.classList.contains('drawer--is-open') ||
              cartDrawerWrapper.hasAttribute('open') ||
              cartDrawerWrapper.getAttribute('aria-hidden') === 'false')) ||
          (cartSidebar &&
            (cartSidebar.classList.contains('is-open') ||
              cartSidebar.classList.contains('drawer--is-open') ||
              cartSidebar.getAttribute('aria-hidden') === 'false'));

        if (isCartOpen) {
          hideStickyButton();
          return;
        }

        // Show/hide sticky button based on scroll
        const addToCartRect = addToCartButton.getBoundingClientRect();
        const buttonBottom = addToCartRect.bottom;
        const shouldBeVisible = buttonBottom < scrollThreshold;

        if (shouldBeVisible !== isVisible) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            if (shouldBeVisible) {
              showStickyButton();
            } else {
              if (buttonBottom > scrollThreshold + 150) {
                hideStickyButton();
              }
            }
          }, 50);
        }
      }

      function showStickyButton() {
        if (isVisible) return;
        stickyElement.style.display = 'block';
        void stickyElement.offsetWidth; // reflow
        stickyElement.classList.add('show');
        isVisible = true;
      }

      function hideStickyButton() {
        if (!isVisible) return;
        stickyElement.classList.remove('show');
        setTimeout(() => {
          if (!stickyElement.classList.contains('show')) {
            stickyElement.style.display = 'none';
          }
          isVisible = false;
        }, 400);
      }

      // Event listeners
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });

      // Cart open detection - both GemPages AND standard Shopify
      document.addEventListener('click', function (e) {
        if (
          e.target.closest(
            '[data-action="open-drawer"], [data-open-cart], .js-drawer-open-cart, .cart-link, .gp-cart-link'
          )
        ) {
          setTimeout(handleScroll, 100);
        }
      });

      // All cart events - standard Shopify AND GemPages
      document.addEventListener('cart:open', handleScroll);
      document.addEventListener('cart-drawer:open', handleScroll);
      document.addEventListener('cart.requestStarted', handleScroll);
      document.addEventListener('cartDrawerOpened', handleScroll);
      document.addEventListener('gp:cart:open', handleScroll);

      // Observe cart drawer mutations
      const drawerObserver = new MutationObserver(function (mutations) {
        for (let mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            (mutation.attributeName === 'aria-hidden' ||
              mutation.attributeName === 'class' ||
              mutation.attributeName === 'open')
          ) {
            handleScroll();
          }
        }
      });

      const cartDrawers = document.querySelectorAll(
        'cart-drawer, #sidebar-cart, #CartDrawer, .cart-drawer, gp-cart-drawer'
      );
      cartDrawers.forEach(drawer => {
        drawerObserver.observe(drawer, { attributes: true });
      });

      // Initial triggers
      setTimeout(handleScroll, 300);
      setInterval(handleScroll, 2000);
      
      console.log('Sticky add to cart initialized successfully for:', addToCartButton);
    }
  }
});

// Utility
function scrollToTop(event) {
  event.preventDefault();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
window.scrollToTop = scrollToTop;